// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5d7aafed","453":"3a73f1a5","455":"28af2eca","977":"da91dbdd"}[chunkId] + ".chunk.js";
};